mutation uploadAvatarMutation($input: UploadAvatarInput!) {
  personAvatar: uploadAvatar(input: $input) {
    success
    originalAvatarUrl
    croppedAvatarUrl
    error
  }
}
